module.exports = __webpack_public_path__ + "static/media/redPic.4ec07eac.jpg";